import React from "react";
import Loadable from "react-loadable";
import {LoadingLogo} from "./components/loading/loading-logo";

function Loading(props) {
	return (
		<LoadingLogo
			loading={props.isLoading}
			style={{position: "absolute", height: "100%", width: '100%'}}
		/>
	);
}

const StepA = Loadable({
	loader: () => import("./views/Base/Jobs/CreatePosition/StepA"),
	loading: Loading,
});

const Cards = Loadable({
	loader: () => import("./views/Base/Jobs"),
	loading: Loading,
});

const ResumeView = Loadable({
	loader: () => import("./views/Base/ResumeView"),
	loading: Loading,
});

const Requisitions = Loadable({
	loader: () => import("./views/Base/Requisitions"),
	loading: Loading,
});

const Dashboard = Loadable({
	loader: () => import("./views/Dashboard"),
	loading: Loading,
});

const BigCalendar = Loadable({
	loader: () => import("./views/Communication/Calendar"),
	loading: Loading,
});

const Messages = Loadable({
	loader: () => import("./views/Communication/Messages"),
	loading: Loading,
});

const Profile = Loadable({
	loader: () => import("./views/Settings/Profile"),
	loading: Loading,
});

const Page404 = Loadable({
	loader: () => import("./views/Pages/Page404"),
	loading: Loading,
});

const Settings = Loadable({
	loader: () => import("./views/Pages/Page404"),
	loading: Loading,
});

const Report = Loadable({
	loader: () => import("./views/Pages/Report"),
	loading: Loading,
});

const Branding = Loadable({
	loader: () => import("./views/Settings/Branding/Branding"),
	loading: Loading,
});

const Help = Loadable({
	loader: () => import("./views/Pages/Help/Help"),
	loading: Loading,
});

const GettingStarted = Loadable({
	loader: () => import("./views/Pages/Help/GettingStarted"),
	loading: Loading,
});

const TipsAndTricks = Loadable({
	loader: () => import("./views/Pages/Help/TipsAndTricks"),
	loading: Loading,
});

const UsingTalentscript = Loadable({
	loader: () => import("./views/Pages/Help/UsingTalentscript"),
	loading: Loading,
});

const Troubleshooting = Loadable({
	loader: () => import("./views/Pages/Help/Troubleshooting"),
	loading: Loading,
});

const PaymentFail = Loadable ({
	loader:() => import ("./views/Payments/PaymentFail"),
	loading: Loading,

});

const PaymentSuccess = Loadable ({
	loader: () => import ("./views/Payments/PaymentSuccess"),
	loading: Loading,

})

const PaypalResult = Loadable ({
	loader: () => import ("./views/Payments/PaypalResult"),
	loading: Loading,

})

const Verifications = Loadable ({

	loader: () => import ("./views/Verifications/Verifications"),
	loading: Loading,
})


const TalentPool = Loadable ({

	loader: () => import ("./views/TalentPool/TalentPool"),
	loading: Loading,
})





//Alpha or Test features


// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
	{path: "/home", exact: true, name: "Home", component: Dashboard},
	{path: "/", exact: true, component: Dashboard},
	{path: "/base/jobs", exact: true, name: "Jobs", component: Cards},
	{path: "/base/jobs/new", exact: false, name: "Create New Position", component: StepA},
	{path: "/base/jobs/edit", exact: false, name: "Edit Existing Position", component: StepA},
	{path: "/base/resumes", exact: true, name: "Resumes", component: ResumeView},
	{path: "/base/requisitions", exact: true, name: "Requisitions", component: Requisitions},
	{path: "/base/requisitions/report", exact: true, name: "Report", component: Report},
	{path: "/base/requisitions/:id", exact: true, name: "Requisitions", component: Requisitions},
	{path: "/communication", exact: true, name: "Communication"},
	{path: "/communication/calendar", name: "Calendar", component: BigCalendar},
	{path: "/communication/messages", name: "Messages", component: Messages},
	{path: "/misc/settings", name: "Settings", component: Settings},
	{path: "/settings/profile", name: "Profile", component: Profile},
	{path: "/settings/branding", name: "Branding", component: Branding},
	{path: "/misc/help", exact: true, name: "Help", component: Help},
	{path: "/misc/help/GettingStarted", exact: true, name: "GettingStarted", component: GettingStarted},
	{path: "/misc/help/tipsandtricks", exact: true, name: "TipsAndTricks", component: TipsAndTricks},
	{path: "/misc/help/usingtalentscript", exact: true, name: "UsingTalentscript", component: UsingTalentscript},
	{path: "/misc/help/troubleshooting", exact: true, name: "Troubleshooting", component: Troubleshooting},
	{path: "/payment/paymentsuccess", exact: true, name: "PaymentSuccess", component: PaymentSuccess},
	{path: "/payment/paymentfail", exact: true, name: "PaymentFailed", component: PaymentFail},
	{path:"/payment/paypal",exact: true, name: "PaypalResult", component: PaypalResult},
	{path:"/verifications", exact:true, name: "Verifications", component:Verifications},
	{path:"/talentpool", exact:true, name: "TalentPool", component:TalentPool},


	{component: Page404}
];

export default routes;
